export default __webpack_public_path__ + "static/media/not-data.66810d1a.png";